(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5445],{

/***/ 85445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62062);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var ab_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(276);
/* harmony import */ var _ab_informes_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21205);
/* harmony import */ var _ab_informes_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ab_informes_scss__WEBPACK_IMPORTED_MODULE_4__);





var Informes = function(param) {
    var _title = param.title, title = _title === void 0 ? "Nuestros informes" : _title, text = param.text, informes = param.informes, i18n = param.i18n;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common", {
        i18n: i18n
    }).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-informes",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "details",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        element: "h2",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "informes",
                children: informes ? informes.map(function(itm) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "informe-card",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: itm === null || itm === void 0 ? void 0 : (ref = itm.image) === null || ref === void 0 ? void 0 : ref.mediaItemUrl,
                                alt: itm.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                element: "h4",
                                children: itm.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                prefetch: false,
                                text: t("descargar"),
                                href: itm === null || itm === void 0 ? void 0 : (ref1 = itm.archivo) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl,
                                target: "_blank"
                            })
                        ]
                    });
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "informe-card",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/images/informe-1.png",
                                    alt: t("memoriaRSE") + " " + "2020"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    element: "h4",
                                    children: t("memoriaRSE") + " " + "2020"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    prefetch: false,
                                    text: t("descargar"),
                                    href: "https://www.abadia-retuerta.com/wp-content/uploads/2021/04/Memoria-Responsabilidad-social-empresarial-2020-2.pdf",
                                    target: "_blank"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "informe-card",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/images/informe-2.png",
                                    alt: t("memoriaRSE") + " " + "2019"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    element: "h4",
                                    children: t("memoriaRSE") + " " + "2019"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    prefetch: false,
                                    text: t("descargar"),
                                    href: "https://www.abadia-retuerta.com/wp-content/uploads/2021/04/Informe-de-Responsabilidad-Social-Empresarial-2019.pdf",
                                    target: "_blank"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "informe-card",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/images/informe-3.png",
                                    alt: t("memoriaRSE") + " " + "2018"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    element: "h4",
                                    children: t("memoriaRSE") + " " + "2018"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    prefetch: false,
                                    text: t("descargar"),
                                    href: "https://www.abadia-retuerta.com/wp-content/uploads/2020/11/memoria-RSE-Abadia-Retuerta-cas-2018.pdf",
                                    target: "_blank"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "informe-card",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/images/informe-4.png",
                                    alt: t("memoriaRSE") + " " + "2017"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    element: "h4",
                                    children: t("memoriaRSE") + " " + "2017"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    prefetch: false,
                                    text: t("descargar"),
                                    href: "https://www.abadia-retuerta.com/wp-content/uploads/2019/06/Memoria-RSE-ARLD-2017-2.pdf",
                                    target: "_blank"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "informe-card",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/images/informe-5.png",
                                    alt: t("memoriaRSE") + " " + "2016"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    element: "h4",
                                    children: t("memoriaRSE") + " " + "2016"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    prefetch: false,
                                    text: t("descargar"),
                                    href: "https://www.abadia-retuerta.com/wp-content/uploads/2019/06/Memoria-RSE-ARLD-2016-10.pdf",
                                    target: "_blank"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Informes);


/***/ }),

/***/ 21205:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);